
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.1528 7H5.84709C5.35825 7 4.94106 7.35341 4.8607 7.8356L3.19403 19.8356C3.09244 20.4451 3.56248 21 4.18042 21H19.8195C20.4374 21 20.9075 20.4451 20.8059 19.8356L19.1392 7.8356C19.0589 7.35341 18.6417 7 18.1528 7Z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    